import api from "../../Api";
import { BaseService } from "../../BaseService";


const URL = 'articles/search';

export class ArticlesSearchService extends BaseService {
    async search(params: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/semantic`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}